<template>
    <div class="c-algolia-search__results">
        <div v-if="hasSearched && loading">
            <div class="c-algolia-search__note">Loading search results...</div>
        </div>

        <div v-if="!loading && !hasSearched && !newsMediaPage">
            <div class="c-algolia-search__note">
                <i>Please enter a search query in the sidebar and click search.</i>
            </div>
        </div>

        <div v-if="hasSearched && searchText">

            <div
                v-if="searchResult.results.length == 0 && !loading && hasSearched"
                class="c-algolia-search__note"
            >
                Sorry, there are no results for "{{ lastSearchedFor.searchText }}" in
                {{ lastSearchedFor.selectedCategories.join(', ') }}.
            </div>

        </div>

        <div
            v-if="searchResult.results.length > 0 && !loading"
            class="c-algolia-search__note"
        >
            Searched {{ lastSearchedFor.selectedCategories.join(', ') }} for "{{
            lastSearchedFor.searchText
            }}" and got {{ searchResult.totalResults }} results.

            <span v-if="searchResult.totalPages > 1">
                Showing page {{ searchResult.currentPage }} of
                {{ searchResult.totalPages }}.
            </span>
        </div>

        <div class="c-algolia-search__results-wrapper">
            <div
                :class="[
                    'c-algolia-search__loading-animation',
                    { 'c-algolia-search__loading-animation--visible': loading },
                ]"
            >
                <div class="c-algolia-search__loading-wrapper">
                    <div class="c-algolia-search__loading-ring"></div>
                </div>
            </div>

            <NewsMediaArticles v-if="newsMediaPage && !hasSearched" />

            <div
                v-if="hasSearched"
                v-for="result in searchResult.results"
                :class="[
                    `c-algolia-search__result`,
                    { 'c-algolia-search__result--loading': loading },
                ]"
                :key="result.title + result.id"
            >
                <div class="c-algolia-search__result-wrapper">

                    <p class="c-algolia-search__result-meta">
                        Updated
                        {{ result.date }}
                    </p>

                    <h3 class="c-algolia-search__result-title">
                        <a :href="result.url" class="c-algolia-search__result-link">
                            {{ result.title }}
                            <small v-if="result.className == 'File' && result.url">
                                ({{ getFileExtension(result.url) }})</small
                            >
                        </a>
                    </h3>

                    <p 
                        v-if="result.excerpt" 
                        class="c-algolia-search__result-excerpt"
                    >
                        <span v-html="result.excerpt"></span>
                        <a                        
                            class="c-algolia-search__result-readmore"
                            :href="result.url"
                        >
                            Read more
                        </a>
                    </p>

                    <p v-if="result.pageCategory" class="c-algolia-search__result-category">
                        {{ result.pageCategory }}
                    </p>
                    
                </div>
            </div>

            <div
                class="c-algolia-search__pagination"
                v-if="searchResult.results.length > 0"
            >
                <button
                    class="c-algolia-search__pagination-button"
                    v-if="searchResult.currentPage > 1"
                    @click="prevPageSearch"
                >
                    Prev
                </button>
                <div v-else></div>

                <div class="c-algolia-search__pagination-pages-wrapper">
                    <button
                        v-for="page in searchResult.totalPages"
                        @click="goToPage(page)"
                        :key="page"
                        :class="[
                        'c-algolia-search__pagination-button',
                        {
                            'c-algolia-search__pagination-button--active':
                            page === searchResult.currentPage,
                        },
                        ]"
                    >
                        {{ page }}
                    </button>
                </div>

                <button
                    class="c-algolia-search__pagination-button"
                    v-if="searchResult.currentPage < searchResult.totalPages"
                    @click="nextPageSearch"
                >
                    Next
                </button>
                <div v-else></div>

            </div>

        </div>

    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import NewsMediaArticles from "./NewsMediaArticles.vue";

export default {
    components: {
        NewsMediaArticles,
    },
    data() {
        return {
            newsMediaPage: false,
        };
    },
    mounted() {
        if (!this.$store.state.searchApp.state.hasSearched && document.querySelector(".news-media-search")) { 
            this.newsMediaPage = true;

            // get initial featured article and 8 latest articles
            this.$store.dispatch("fetchArticles");
        }
    },
    computed: {
        ...mapFields([
            "searchApp.lastSearchedFor",
            "searchApp.searchResult",
            "searchApp.state.hasSearched",
            "searchApp.state.loading",
            "searchApp.search.start",
            "searchApp.search.searchText",
            "searchApp.search.category",
            "searchApp.featuredArticle",
            "searchApp.initialArticles",
            "searchApp.articlePagination",
        ]),
    },
    methods: {
        goToPage(page) {
            this.start = (page - 1) * 15;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        nextPageSearch() {
            this.start = this.searchResult.nextStart;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        prevPageSearch() {
            this.start = this.searchResult.prevStart;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        scrollToResults() {
            const pageHeader = document.querySelector(".c-algolia-search__results");
            if (pageHeader) {
                pageHeader.scrollIntoView({ behavior: "smooth" });
            }
        },
        getFileExtension(url) {
            return url?.includes(".") ? url.split(".").pop() : "";
        },
        changePage(page) {
            this.$store.dispatch("fetchArticles", page);
        }
    },
};

</script>